import script from "./AttributeComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./AttributeComponent.vue?vue&type=script&setup=true&lang=ts"

import "./AttributeComponent.vue?vue&type=style&index=0&id=24d58866&lang=css"

const __exports__ = script;

export default __exports__